import React, { useState } from "react";
import { Check, X, RotateCcw } from "lucide-react";
import { updatePhoto } from "../api";
import { toast } from "sonner";

const CuratorView = ({ projectId, photos, onUpdate }) => {
  const pendingPhotos = photos.filter(p => p.status === 'pending');
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleDecision = async (status) => {
    if (pendingPhotos.length === 0) return;
    
    const photo = pendingPhotos[currentIndex];
    try {
      await updatePhoto(projectId, photo.id, { status });
      toast.success(status === 'accepted' ? "Kept photo" : "Discarded photo");
      onUpdate(); 
      // Note: onUpdate will refresh photos, so pendingPhotos changes. 
      // If we are at index 0, the next one naturally slides in.
    } catch (err) {
        toast.error("Failed to update status");
    }
  };

  if (pendingPhotos.length === 0) {
    return (
      <div className="text-center py-20">
        <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <Check className="w-8 h-8" />
        </div>
        <h3 className="text-xl font-bold text-slate-900">All caught up!</h3>
        <p className="text-slate-500 mt-2">No pending photos to review.</p>
        <p className="text-sm text-slate-400 mt-4">Check the Book View to see your selected photos.</p>
      </div>
    );
  }

  const currentPhoto = pendingPhotos[currentIndex];

  return (
    <div className="max-w-md mx-auto">
      <div className="relative aspect-[3/4] bg-slate-900 rounded-2xl overflow-hidden shadow-2xl mb-8">
        <img 
          src={`${process.env.REACT_APP_BACKEND_URL}${currentPhoto.url}`} 
          alt={currentPhoto.filename}
          className="w-full h-full object-contain"
        />
        <div className="absolute top-0 left-0 right-0 p-4 bg-gradient-to-b from-black/50 to-transparent text-white">
            <p className="text-sm font-medium truncate">{currentPhoto.filename}</p>
        </div>
      </div>

      <div className="flex items-center justify-center gap-6">
        <button
          onClick={() => handleDecision('rejected')}
          className="w-16 h-16 bg-white border border-slate-200 text-red-500 rounded-full flex items-center justify-center shadow-sm hover:bg-red-50 hover:border-red-200 transition-colors"
        >
          <X className="w-8 h-8" />
        </button>
        <div className="text-sm font-medium text-slate-500">
             {pendingPhotos.length} remaining
        </div>
        <button
          onClick={() => handleDecision('accepted')}
          className="w-16 h-16 bg-indigo-600 text-white rounded-full flex items-center justify-center shadow-lg hover:bg-indigo-700 transition-colors"
        >
          <Check className="w-8 h-8" />
        </button>
      </div>
    </div>
  );
};

export default CuratorView;
